import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * Status badge — uses .badge + kind classes from kit.css.
 *
 *   ok : success (pass)
 *   ko : danger  (fail)
 *   run: info    (running)
 *   wr : warning (warn / skip)
 *   nt : neutral
 *
 * The `.dot` child is rendered automatically so usage stays terse :
 *   <Badge kind="run">En cours</Badge>
 */
export type BadgeKind = 'ok' | 'ko' | 'run' | 'wr' | 'nt';

export interface BadgeProps {
  kind?: BadgeKind;
  mono?: boolean;
  children: ReactNode;
  className?: string;
}

export function Badge({ kind = 'nt', mono, children, className }: BadgeProps) {
  return (
    <span className={cn('badge', kind, mono && 'mono', className)}>
      <span className="dot" />
      {children}
    </span>
  );
}
